import React from 'react';

import QRCode from 'qrcode.react';

import PropTypes from 'prop-types';

import {
  QrCodeContainer,
  QrCodeTitle,
  QrCodeSubTitle,
  QrCodeImage,
  QrCodeLink,
  QrCodeButton,
  ActionQrCodeArea,
} from './styles';

import link from '~/assets/icons/link.svg';

function Qrcode({
  setOpen,
  token = '',
  showingData = null,
  prescriptionItems = null,
  setModalAsOpen,
  validationCode = false,
  setpdfOpen,
  setQrCodeValidation,
}) {
  const tokenRef = `${process.env.REACT_APP_FARMACEUTICO_URL}receita/${token}`;

  return (
    <QrCodeContainer showingData={showingData}>
      <QrCodeTitle data-testid="validationKey">
        Chave de validação: {token}
      </QrCodeTitle>
      <QrCodeSubTitle>
        Para comprar, mostre este código ao farmacêutico:
      </QrCodeSubTitle>
      <QrCodeImage>
        <QRCode value={tokenRef} />
      </QrCodeImage>
      <QrCodeLink>
        <a href={`https://${tokenRef}`} rel="noreferrer">
          <img src={link} alt="validação" />
          {`${process.env.REACT_APP_FARMACEUTICO_URL}receita/${token}`}
        </a>
      </QrCodeLink>
      {prescriptionItems &&
        prescriptionItems.some(
          (prescriptionItem) => !!prescriptionItem.controlled
        ) && (
          <ActionQrCodeArea>
            <QrCodeButton
              onClick={() => {
                if (validationCode) {
                  setpdfOpen();
                } else {
                  setModalAsOpen(true);
                  setQrCodeValidation(true);
                }
              }}
            >
              Visualizar documentação
            </QrCodeButton>
          </ActionQrCodeArea>
        )}
      <QrCodeButton
        onClick={() => {
          if (setOpen) setOpen(true);
        }}
      >
        Mais informações
      </QrCodeButton>
    </QrCodeContainer>
  );
}

Qrcode.propTypes = {
  setOpen: PropTypes.func.isRequired,
  token: PropTypes.string.isRequired,
  showingData: PropTypes.any,
  setModalAsOpen: PropTypes.any,
  validationCode: PropTypes.any,
  prescriptionItems: PropTypes.any,
  setQrCodeValidation: PropTypes.any,
  setpdfOpen: PropTypes.func.isRequired,
};

Qrcode.defaultProps = {
  showingData: null,
  setModalAsOpen: null,
  validationCode: null,
  prescriptionItems: null,
  setQrCodeValidation: null,
};

export default Qrcode;
